exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".a11yHidden-fb12d{clip:rect(0 0 0 0);clip-path:inset(50%);overflow:hidden;position:absolute;white-space:nowrap;width:0}", ""]);

// Exports
exports.locals = {
	"a11yHidden": "a11yHidden-fb12d"
};